import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
import { LOGO_URL, BUSINESS } from '@/data/site';
import { EASE } from '@/lib/motion';

export default function AgeGate() {
  const [verified, setVerified] = useState(() => localStorage.getItem('mg_age_verified') === '1');
  const [denied, setDenied] = useState(false);

  const confirm = () => {
    localStorage.setItem('mg_age_verified', '1');
    setVerified(true);
  };

  return (
    <AnimatePresence>
      {!verified && (
        <motion.div
          data-testid="age-gate"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0, transition: { duration: 0.5 } }}
          className="fixed inset-0 z-[100] flex items-center justify-center bg-black/90 backdrop-blur-2xl px-6"
        >
          <motion.div
            initial={{ opacity: 0, y: 30, scale: 0.97 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            transition={{ duration: 0.8, ease: EASE, delay: 0.15 }}
            className="w-full max-w-md border border-ink/10 bg-surface p-10 text-center"
          >
            <img src={LOGO_URL} alt="Majestic Greens DMV logo" className="mx-auto h-24 w-24 rounded-full" />
            <p className="mt-6 text-[11px] font-semibold uppercase tracking-[0.35em] text-bronze">Adults Only</p>
            <h2 className="mt-3 font-serif text-3xl text-ink">Are you 21 or older?</h2>
            <p className="mt-4 text-sm leading-relaxed text-sage">
              {BUSINESS.name} serves adults 21+ in Washington, DC. Please confirm your age to enter.
            </p>
            {denied ? (
              <p data-testid="age-gate-denied" className="mt-6 text-sm text-oxblood">
                You must be 21 or older to access this site. Please come back when you're of legal age.
              </p>
            ) : (
              <div className="mt-8 flex flex-col gap-3">
                <button
                  data-testid="age-gate-confirm-button"
                  onClick={confirm}
                  className="group flex items-center justify-center gap-2 bg-gold px-8 py-4 text-xs font-bold uppercase tracking-[0.25em] text-ink transition-colors duration-300 hover:bg-bronzehover"
                >
                  <ShieldCheck className="h-4 w-4" /> I am 21 or older
                </button>
                <button
                  data-testid="age-gate-deny-button"
                  onClick={() => setDenied(true)}
                  className="border border-ink/15 px-8 py-4 text-xs font-semibold uppercase tracking-[0.25em] text-sage transition-colors duration-300 hover:border-ink/30 hover:text-ink"
                >
                  I am under 21
                </button>
              </div>
            )}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
